// src/utils/queryClient.js
import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,       // 30s — data stays fresh
      retry: 1,                    // retry once on fail
      refetchOnWindowFocus: false, // don't refetch when tab regains focus
    },
  },
});

export default queryClient;